<template>
    <PopupRouterViewDetail label="Combine Case Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Combine Case" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-datepicker id="fieldset-combine-date" label-cols-lg="12"  label="Combine Date" size="sm" :model.sync="model.combineDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-label label-cols-lg="12" size="sm" label="Control Card" :model="(model.controlCard != null) ? model.controlCard.controlCardNumber : null"  />
						<app-label label-cols-lg="12" size="sm" label="Combine Qty" :model="(model.part != null) ? model.part.standarPackagingQty : null"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Part Number" :model="(model.part != null) ? model.part.partNumber : null"  />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.part != null) ? model.part.partName : null"  />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Combine Case Detail" :bordered="true" :items="combineCaseDetails" :fields="fieldsCombineCaseDetail" :busy="isDataLoading" :sort-by.sync="sortByCombineCaseDetail" :sort-desc.sync="sortDescCombineCaseDetail" small responsive
			@editButtonMethod="editRowDataCombineCaseDetail"
			@deleteButtonMethod="deleteRowDataCombineCaseDetail"
			@showPopupAddMethod="resetDataCombineCaseDetail()"
			@showPopupUploadMethod="showPopupUploadCombineCaseDetail()"
			@downloadMethod="downloadCombineCaseDetail()"
			@addFromClipboardMethod="addFromClipboardCombineCaseDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardCombineCaseDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadCombineCaseDetail"
			>
			<template #top-row v-if="isShowCombineCaseDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterCombineCaseDetail.controlCardId" :reduce="item => item.id" v-model="filterCombineCaseDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-qty-control-card-table" v-model="filterCombineCaseDetail.qtyControlCard" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After">
					<b-form-input id="input-qty-after-table" v-model="filterCombineCaseDetail.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Taken Qty">
					<b-form-input id="input-taken-qty-table" v-model="filterCombineCaseDetail.takenQty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( combineCaseDetailPageSize * (currentCombineCaseDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-combine-case-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputCombineCaseDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isUpdatable="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(qtyControlCard)="row">
				<app-input-textbox :id="'input-combine-case-detail-qty-control-card-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qtyControlCard"   @change="saveInputCombineCaseDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(takenQty)="row">
				<app-input-textbox :id="'input-combine-case-detail-taken-qty-' + row.index" label-cols-lg="12" label="Taken Qty" size="sm" :model.sync="row.item.takenQty"   @change="saveInputCombineCaseDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyAfter)="row">
				<app-input-textbox :id="'input-combine-case-detail-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputCombineCaseDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<CombineCaseDetailInput 
					:openPopup="isShowPopupCombineCaseDetail"
					:modelId="combineCaseDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataCombineCaseDetail"/>
			</template>
			<template v-slot:upload-detail>
				<CombineCaseDetailUpload
					:openPopup="isShowPopupUploadCombineCaseDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataCombineCaseDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-combine-case-detail-qty-control-card-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qtyControlCard"   @change="saveInputCombineCaseDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-combine-case-detail-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputCombineCaseDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-combine-case-detail-taken-qty-' + row.index" label-cols-lg="12" label="Taken Qty" size="sm" :model.sync="row.item.takenQty"   @change="saveInputCombineCaseDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

		<template #modal-left-button>
			<b-button size="sm" @click="printCombineControlCard" variant="outline-success">Print PCC</b-button>
		</template>

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import CombineCase from '@/models/CombineCase/CombineCase';
import CombineCaseList from '@/models/CombineCase/CombineCaseList';
import CombineCaseFilter from '@/filters/CombineCase/CombineCaseFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import CombineCaseDetail from '@/models/CombineCase/CombineCaseDetail';
import CombineCaseDetailFilter from '@/filters/CombineCase/CombineCaseDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import CombineCaseDetailInput from '@/views/CombineCase/CombineCaseDetailInput';
import CombineCaseDetailUpload from '@/views/CombineCase/CombineCaseDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		CombineCaseDetailInput,CombineCaseDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			combineDate: {required},
			controlCardId: {required},
			partId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				combineDate: { required : "Combine Date is Required."},
				controlCardId: { required : "Control Card is Required."},
				partId: { required : "Part is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsCombineCaseDetail: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"qtyControlCard": { "class" : "th-qty-control-card", "label" : "Qty Before", key: 'qtyControlCard', sortable: false}}, 
				{"takenQty": { "class" : "th-taken-qty d-stack-none", "label" : "Qty Used", key: 'takenQty', sortable: false}}, 
				{"qtyAfter": { "class" : "th-qty-after last-child", "label" : "Qty After", key: 'qtyAfter', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelCombineCaseDetail : {},
			isShowPopupCombineCaseDetail : false,
			isShowPopupUploadCombineCaseDetail : false,
			filterCombineCase : null,
			currentCombineCasePage : 1,
			combineCasePageSize: 10,
			sortByCombineCase: '',
			sortDescCombineCase: '',
			filterCombineCaseDetail : null,
			currentCombineCaseDetailPage : 1,
			combineCaseDetailPageSize: 10,
			sortByCombineCaseDetail: '',
			sortDescCombineCaseDetail: '',
			sortingByCombineCaseDetail: [],
			combineCaseDetails : [],
			combineCaseDetailId : '',
			totalCombineCaseDetailRow : 0,
			isShowCombineCaseDetailFilter: false,
			isDownloadCombineCaseDetail: false,
			controlCards: [],
			parts: [],
			parts: [],
			isPartComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isCombineCaseComboLoading: false,
		}
	},
	methods : {
		printCombineControlCard : async function() {
			let id = this.model.id;
			let data = await CombineCase.printCombineControlCard(this, id);
			if(data) {
				this.toast({message: 'Print Control Card Success', title: 'Success', variant: 'success'});
			} else {
				this.toast({ message: 'Something error when print pcc data', title: 'Error', variant: 'danger' });
			}
		},
		getCombineCase : async function(id) {
			this.isBusy = true;
			CombineCase.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.partId != null) {
					promises.push(
						this.getPart(this.model.partId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadCombineCase = true;
			this.filterCombineCase.id = this.modelId;
			CombineCase.downloadDataDetail(this, this.filterCombineCase).then(result => {
				this.isDownloadCombineCase = false;
			}).catch(error => { this.isDownloadCombineCase = false; })
		},
		getCombineCaseDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterCombineCaseDetail);
			if (this.modelId == null) return;
			filter.combineCaseId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByCombineCaseDetail != null) {
				this.sortingByCombineCaseDetail[this.sortByCombineCaseDetail] = this.sortDescCombineCaseDetail;
			}
			let currentPage = (this.currentCombineCaseDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalCombineCaseDetailRow + 1;
				let page = Math.ceil(totalData/this.combineCaseDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.combineCaseDetailPageSize = 0;
			// disable paging end
			CombineCaseDetail.getList(this, filter, this.sortingByCombineCaseDetail, currentPage , this.combineCaseDetailPageSize).then(result => {
				this.currentCombineCaseDetailPage = currentPage + 1;
				this.combineCaseDetails = result.data;
				this.totalCombineCaseDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getCombineCases : async function(input) {
			let filter = new CombineCaseFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isCombineCaseComboLoading = true;
			CombineCase.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.combineCases = result.data
				}
				this.isCombineCaseComboLoading = false;
			})
			.catch(error => {});
		},
		getCombineCases : async function(input) {
			let filter = new CombineCaseFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isCombineCaseComboLoading = true;
			CombineCase.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.combineCases = result.data
				}
				this.isCombineCaseComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onControlCardChange : async function() {
			let item = this.model.controlCardId;
			let controlCardObj = this.controlCards.filter(function(controlCard){ return controlCard.id == item; });
			this.model.controlCard = controlCardObj.length > 0 ? controlCardObj[0] : null;
		},

		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.part = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.combineCaseInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					CombineCase.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'combinecaseindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					CombineCase.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'combinecaseindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					CombineCase.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getCombineCase(id);
					});
				}
			});
		},
		onHidden() {
			this.getCombineCases();
		},
		addRowDataCombineCaseDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.combineCaseId =  this.modelId;
					CombineCaseDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getCombineCaseDetails(true);
						this.isShowPopupCombineCaseDetail = false;
					})
				} else {
					model.combineCaseId =  this.modelId;
					CombineCaseDetail.createDataDetail(this, model)
					.then(result => {
						this.getCombineCaseDetails(true);
						this.isShowPopupCombineCaseDetail = false;
					})
				}
			}
		},
		async editRowDataCombineCaseDetail(id) {
			this.combineCaseDetailId = id;
			this.isShowPopupCombineCaseDetail = true; 
		},
		async deleteRowDataCombineCaseDetail(id) {
			CombineCaseDetail.deleteData(this, id).then(result => { this.getCombineCaseDetails(); });
		},
		async resetDataCombineCaseDetail() {
			this.combineCaseDetailId = "";
			this.isShowPopupCombineCaseDetail = true;
		},
		async addDataCombineCaseDetail() {
			CombineCaseDetail.createData(this, { combineCaseId: this.modelId })
			.then(result => {
				this.getCombineCaseDetails(true);
			})
		},
		async addFromClipboardCombineCaseDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, combineCaseId: this.modelId });
				});
				CombineCaseDetail.addFromClipboard(this, controlCards).then(result => { this.getCombineCaseDetails() });
			});
		},
		async replaceFromClipboardCombineCaseDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, combineCaseId: this.modelId });
				});
				CombineCaseDetail.replaceFromClipboard(this, controlCards).then(result => { this.getCombineCaseDetails() });
			});   
		},
		showPopupUploadCombineCaseDetail() {
			if(this.combineCaseDetails != null && this.combineCaseDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap CombineCaseDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadCombineCaseDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadCombineCaseDetail = true;
			}
		},
		uploadDataCombineCaseDetail(modalEvent, newDatas) {
			this.isShowPopupUploadCombineCaseDetail = false; 
		},
		downloadCombineCaseDetail(modalEvent) {
			this.isDownloadCombineCaseDetail = true;
			this.filterCombineCaseDetail.combineCaseId = this.modelId;
			CombineCaseDetail.downloadDataDetail(this, this.filterCombineCaseDetail).then(result => {
				this.isDownloadCombineCaseDetail = false;
			}).catch(error => { this.isDownloadCombineCaseDetail = false; })
		},
		saveInputCombineCaseDetail(item) {
			if (this.combineCases != null && this.combineCases != undefined  && this.combineCases.length > 0) {
				item.combineCase = this.combineCases.find(q => q.id == item.combineCaseId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					CombineCaseDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadCombineCaseDetail = false; 
			this.isShowPopupCombineCaseDetail = false; 
			if (modalType == 'CombineCaseDetail') {
				this.getCombineCaseDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowCombineCaseDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterCombineCase = new CombineCaseFilter();
		this.filterCombineCaseDetail = new CombineCaseDetailFilter();
		//this.getCombineCases();
		//this.getControlCards();
		//this.getParts();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getCombineCase(id);
			} else {
				this.modelId = id;
				this.getCombineCase(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByCombineCaseDetail : {
			handler: function() {
				this.getCombineCaseDetails();
			}
		},
		sortDescCombineCaseDetail: {
			handler: function() {
				this.getCombineCaseDetails();
			}
		},
		currentCombineCaseDetailPage: {
			handler: function() {
				this.getCombineCaseDetails();
			}
		},
		combineCaseDetailPageSize : {
			handler: function() {
				this.getCombineCaseDetails();
			}
		},
		filterCombineCaseDetail: {
			handler: function() {
				this.getCombineCaseDetails();
			},
			deep: true,
		},
	},
}
</script>
